import { ArrowRight } from 'lucide-react';
import { archeIconUrl } from '@/lib/arche-icon-url';

interface ArcheSuggestion {
  archId: string;
  name: string;
  simpleDescription: string;
  imageRef: string | null;
}

interface ArcheSuggestionsRowProps {
  suggestions: ArcheSuggestion[];
  onArcheClick: (archId: string) => void;
}

export function ArcheSuggestionsRow({ suggestions, onArcheClick }: ArcheSuggestionsRowProps) {
  if (suggestions.length === 0) return null;

  return (
    <div className="ml-11 mt-3">
      <p className="text-xs text-muted-foreground mb-2 font-medium uppercase tracking-wide">
        Suggested Arches
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
        {suggestions.slice(0, 3).map((arche) => (
          <button
            key={arche.archId}
            onClick={() => onArcheClick(arche.archId)}
            className="flex items-center gap-2.5 p-2.5 rounded-lg bg-card border border-border hover:border-primary/50 hover:bg-accent/50 transition-all text-left group min-w-0"
          >
            {arche.imageRef ? (
              <img
                src={archeIconUrl(arche.imageRef, 64) ?? ''}
                alt={arche.name}
                className="w-8 h-8 rounded-md object-cover flex-shrink-0"
              />
            ) : (
              <div className="w-8 h-8 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0">
                <span className="text-sm font-semibold text-primary">{arche.name.charAt(0)}</span>
              </div>
            )}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-1">
                <span className="text-sm font-medium text-foreground truncate">{arche.name}</span>
                <ArrowRight className="h-3 w-3 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" />
              </div>
              <p className="text-xs text-muted-foreground truncate">{arche.simpleDescription}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
